import { Skeleton } from '@/components/ui/skeleton';
import { cn } from '@/lib/utils';

function MessageBubbleSkeleton({ align }: { align: 'left' | 'right' }) {
  return (
    <div className={cn('flex', align === 'right' ? 'justify-end' : 'justify-start')}>
      <Skeleton
        className={cn(
          'h-20 rounded-[20px]',
          align === 'right' ? 'w-[58%] rounded-br-[7px]' : 'w-[64%] rounded-bl-[7px]'
        )}
      />
    </div>
  );
}

export function TicketChatSkeleton() {
  return (
    <div className="flex h-full min-h-0 flex-1 flex-col overflow-hidden">
      <div className="flex shrink-0 items-start gap-4 border-b px-5 py-4">
        <div className="flex min-w-0 flex-1 items-start gap-3">
          <Skeleton className="h-[46px] w-[46px] shrink-0 rounded-full" />
          <div className="min-w-0 space-y-2">
            <Skeleton className="h-5 w-full max-w-md" />
            <Skeleton className="h-5 w-48 max-w-full" />
            <div className="flex flex-wrap gap-2">
              <Skeleton className="h-6 w-16 rounded-full" />
              <Skeleton className="h-6 w-20 rounded-full" />
              <Skeleton className="h-4 w-24" />
            </div>
          </div>
        </div>
        <div className="flex shrink-0 gap-2 self-center">
          <Skeleton className="h-[38px] w-32 rounded-full" />
          <Skeleton className="h-[38px] w-28 rounded-full" />
        </div>
      </div>

      <div
        className="min-h-0 flex-1 overflow-y-auto px-5 py-6"
        style={{
          background:
            'radial-gradient(circle at top right, color-mix(in oklab, var(--primary-to) 8%, transparent), transparent 26%), var(--muted)',
        }}
      >
        <div className="mb-5 flex justify-center">
          <Skeleton className="h-8 w-40 rounded-full" />
        </div>
        <div className="flex-1 space-y-4">
          <MessageBubbleSkeleton align="left" />
          <MessageBubbleSkeleton align="right" />
          <MessageBubbleSkeleton align="left" />
          <MessageBubbleSkeleton align="right" />
          <MessageBubbleSkeleton align="left" />
        </div>
      </div>

      <div className="flex shrink-0 gap-2.5 border-t bg-white px-4 py-4">
        <Skeleton className="h-11 w-11 shrink-0 rounded-full" />
        <Skeleton className="h-12 flex-1 rounded-[18px]" />
        <Skeleton className="h-[46px] w-28 shrink-0 rounded-full" />
      </div>
    </div>
  );
}
